import { render } from "./SampleSizeBadge.vue?vue&type=template&id=55a25f55&scoped=true"
import script from "./SampleSizeBadge.vue?vue&type=script&lang=js"
export * from "./SampleSizeBadge.vue?vue&type=script&lang=js"

import "./SampleSizeBadge.vue?vue&type=style&index=0&id=55a25f55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a25f55"]])

export default __exports__